export { default, getStaticPaths, getStaticProps } from "@src/Apps/ReleaseNotes";
